




































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { storeSupervisiUmum } from "@/store/modules/SupervisiUmumStore";
import SupervisiUmumSvc from "@/services/SupervisiUmumService";
import { appModule } from "@/store/modules/app";
import moment from "moment";
import SupervisiUmumSeksiChecklist from "./SupervisiUmumSeksiChecklist.vue";

@Component({
  components: { SupervisiUmumSeksiChecklist }
})
export default class SupervisiUmumDetail extends Vue {
  @Prop({ required: true }) sessionData!: any;

  storeModule = storeSupervisiUmum;
  session: any = null;
  loading = false;
  showAckDialog = false;
  ackPassword = "";
  acknowledging = false;

  allSeksiList = [
    { seksi: "kebersihan_tangan", label: "I. Kebersihan Tangan (Hand Hygiene)" },
    { seksi: "apd", label: "II. Alat Pelindung Diri (APD)" },
    { seksi: "limbah", label: "III. Pengelolaan Limbah" },
    { seksi: "lingkungan", label: "IV. Pengendalian Lingkungan" },
    { seksi: "linen", label: "V. Pengelolaan Linen" },
    { seksi: "alat_pasien", label: "VI. Pengelolaan Peralatan Perawatan Pasien" },
    { seksi: "kesehatan_karyawan", label: "VII. Perlindungan Petugas" },
    { seksi: "penyuntikan_aman", label: "VIII. Penyuntikan yang Aman" },
    { seksi: "penempatan_pasien", label: "IX. Penempatan Pasien" },
    { seksi: "etika_batuk", label: "X. Etika Batuk" },
    { seksi: "lumbal_pungsi", label: "XI. Lumbal Pungsi" },
    { seksi: "kewaspadaan_transmisi", label: "XII. Kewaspadaan Berdasarkan Transmisi" },
  ];

  get activeSeksiList() {
    return this.allSeksiList.filter(s => {
      const items = this.getItemsBySeksi(s.seksi);
      return items.length > 0;
    });
  }

  async mounted() {
    this.loading = true;
    await this.storeModule.loadDetail(this.sessionData.id);
    this.session = this.storeModule.currentSession;
    this.loading = false;
  }

  get scoreColor() {
    if (!this.session) return "";
    const s = this.session.compliance_score;
    if (s >= 80) return "green--text";
    if (s >= 60) return "orange--text";
    return "red--text";
  }

  /** Sesi lama masih menyimpan jawaban ya/tidak — skor legacy tetap dirender. */
  get hasLegacyHasil(): boolean {
    if (!this.session?.items) return false;
    return this.session.items.some(
      (i: any) => i.hasil !== null && i.hasil !== undefined && i.hasil !== ""
    );
  }

  getItemsBySeksi(seksi: string) {
    if (!this.session?.items) return [];
    return this.session.items
      .filter((i: any) => i.definition?.seksi === seksi)
      .sort((a: any, b: any) => (a.definition?.urutan || 0) - (b.definition?.urutan || 0))
      .map((i: any) => ({
        definition_id: i.definition_id,
        kode_item: i.definition?.kode_item,
        seksi: i.definition?.seksi,
        urutan: i.definition?.urutan,
        komponen_supervisi: i.definition?.komponen_supervisi,
        tipe_jawaban: i.definition?.tipe_jawaban,
        kritikal: i.definition?.kritikal,
        display_no: this.getDisplayNo(i.definition),
        hasil: i.hasil,
        jumlah_observasi: i.jumlah_observasi,
        jumlah_compliant: i.jumlah_compliant,
        masalah: i.masalah || "",
        rekomendasi: i.rekomendasi || "",
        foto_bukti: i.foto_bukti || [],
      }));
  }

  getDisplayNo(def: any) {
    if (!def) return "";
    const kode = def.kode_item || "";
    const parts = kode.split("-");
    return parts[parts.length - 1] || "";
  }

  formatDate(d: string) {
    return d ? moment(d).format("DD MMMM YYYY") : "-";
  }

  formatDateTime(dt: string) {
    return dt ? moment(dt).format("DD-MM-YYYY HH:mm") : "-";
  }

  printPdf() {
    if (this.session?.id) {
      SupervisiUmumSvc.printPdf(this.session.id);
    }
  }

  async doAcknowledge() {
    if (!this.ackPassword) {
      appModule.NoticeDelay("Password wajib diisi");
      return;
    }
    this.acknowledging = true;
    try {
      const resp = await SupervisiUmumSvc.acknowledge(this.session.id, {
        password: this.ackPassword,
      });
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Berhasil acknowledge supervisi");
        this.showAckDialog = false;
        this.ackPassword = "";
        this.$emit("saved");
        this.$emit("back");
      }
    } catch {
      // handled by ErrorAlert
    }
    this.acknowledging = false;
  }
}
